import { instance } from "@/plugins/axios";
export const checkStatus = async (sessionId) => {
  const data = {
    session_id: sessionId,
  };
  try {
    return await instance.post("/clients/status/", data);
  } catch (e) {
    return null;
  }
};

export const getAgreements = async (checkId, type) => {
  try {
    return await instance.get("/clients/documents/agreements/", {
      params: {
        check_id: checkId,
        file_type: type,
      },
      responseType: "blob",
    });
  } catch (e) {
    return null;
  }
};
